<template>
    <div class="page-container">
        <!-- 头部横幅 -->
        <section class="hero">
            <div class="container">
                <h1>{{ title }}</h1>
                <p>{{ subtitle }}</p>
            </div>
        </section>
        <section class="page-content">
            <div v-for="(dataItem, index) in dataList"  
                :key="index"  
                :class="['module-block', index % 2 === 0 ? 'module-white' : 'module-blue']"
                >
                <div class="module-container">
                    <div class="module-content">
                        <h3>{{ dataItem.title }}</h3>
                        <div v-html="dataItem.desc"></div>
                    </div>
        
                    <!-- 多图片展示区 -->
                    <div class="module-imgs">
                        <img 
                            v-for="(picUrl, index) in dataItem.picList" 
                            :key="index"  
                            :src="picUrl" 
                            class="module-img-item"
                            :alt="`{{dataItem.title}} ${index + 1}`" 
                        >
                    </div>
                </div>
            </div>
        </section>

        <Back></Back>
    </div>
</template>
<script>
import Back from '../components/Back.vue';

export default {
    name: "Exhibitions",
    components: {
        Back
    },
    data() {
        return {
            title: 'International Exhibitions',
            subtitle: 'Global Synergy, Win-Win Cooperation',
            dataList: [
                {
                    title: 'South Africa International Consumer Electronics Exhibition',
                    desc: `<p>As a core technology and trade platform in Southern Africa, it focuses on hot categories such as smart terminals and smart homes, gathers global exhibitors and local professional buyers, centers on targeted business matching, leverages South Africa’s geographical advantages to radiate the entire African market, and serves as a preferred springboard for enterprises to explore the African consumer electronics track.</p>`,
                    picList: [
                        'https://res.roadlinkglb.com/pic/os/cases/banzhan/nanfei_1.jpg',
                        'https://res.roadlinkglb.com/pic/os/cases/banzhan/nanfei_2.jpg',
                        'https://res.roadlinkglb.com/pic/os/cases/banzhan/nanfei_3.jpg'
                    ]
                },
                {
                    title: 'Indonesia International Consumer Electronics Exhibition',
                    desc: `<p>Focusing on smart terminals, smart homes and other popular categories, it gathers global exhibitors and professional buyers. With precise business matching as its core and coupled with industry trend forums, it helps enterprises deepen their presence in the Indonesian and Southeast Asian markets, serving as a preferred platform for expanding cross-border business opportunities.</p>`,
                    picList: [
                        'https://res.roadlinkglb.com/pic/os/cases/banzhan/yindunixiya_2.jpg',
                        'https://res.roadlinkglb.com/pic/os/cases/banzhan/yindunixiya_3.jpg',
                        'https://res.roadlinkglb.com/pic/os/cases/banzhan/yindunixiya_4.jpg'
                    ]
                },
                {
                    title: 'Thailand Big Bang Exhibition',
                    desc: `<p>As a highly influential exhibition in Southeast Asia, it focuses on diverse sectors such as digital technology, gifts and home furnishing. Gathering global exhibitors and professional buyers, it centers on product displays and business matching, coupled with industry trend exchange activities. Taking full advantage of Thailand's geographical advantages, it radiates the entire Southeast Asian market and serves as an excellent platform for enterprises to expand cross-border business opportunities and deepen their presence in the regional market.</p>`,
                    picList: [
                        'https://res.roadlinkglb.com/pic/os/cases/banzhan/taiguo_1.jpg',
                        'https://res.roadlinkglb.com/pic/os/cases/banzhan/taiguo_2.jpg',
                        'https://res.roadlinkglb.com/pic/os/cases/banzhan/taiguo_3.jpg'
                    ]
                },
                {
                    title: 'Dubai-Abu Dhabi International Electronics Exhibition',
                    desc: `<p>As a highly influential technology event in the Middle East, it focuses on cutting-edge categories such as smart terminals and smart homes. Gathering global exhibitors and professional buyers, it centers on product displays and targeted business matching. Leveraging the twin-city hub advantages, it radiates the Middle Eastern and North African markets and serves as an outstanding platform for enterprises to expand cross-border business opportunities.</p>`,
                    picList: [
                        'https://res.roadlinkglb.com/pic/os/cases/banzhan/dibai_1.jpg',
                        'https://res.roadlinkglb.com/pic/os/cases/banzhan/dibai_2.jpg',
                        'https://res.roadlinkglb.com/pic/os/cases/banzhan/dibai_3.jpg'
                    ]
                },
                {
                    title: 'Artificial Intelligence Robot Exhibition',
                    desc: `<p>As a professional event focusing on robotics technology and its applications, it covers diverse categories such as industrial collaborative robots, service robots and smart wearables. Gathering top global R&D enterprises and industry buyers, it builds a bridge for cutting-edge technological exchange and business cooperation through product displays, technical seminars and supply-demand matching activities, helping enterprises seize the first-mover advantage in the intelligent track.</p>`,
                    picList: [
                        'https://res.roadlinkglb.com/pic/os/cases/banzhan/robot_1.jpg',
                        'https://res.roadlinkglb.com/pic/os/cases/banzhan/robot_2.jpg',
                        'https://res.roadlinkglb.com/pic/os/cases/banzhan/robot_3.jpg'
                    ]
                }
            ]
        }
    }
};
</script>

<style scoped>

::v-deep .module-content p {
    text-indent: 2em;
    font-size: 0.95rem;
    line-height: 1.6;
    opacity: 0.9;
}

</style>